module.exports = __webpack_public_path__ + "img/SMT_09_Mr_Sim_Tiong_Kian.807678e7.jpg";